module.exports = __webpack_public_path__ + "static/img/honor_item.e17bf37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor_item.png
// module id = PgKG
// module chunks = 1